// Google Analytics 4 Configuration
// Documentación: https://developers.google.com/analytics

const GA_MEASUREMENT_ID = "G-MTVC96Z9JB";

// Inicializar Google Analytics
export const initGA = (measurementId = GA_MEASUREMENT_ID) => {
  if (typeof window !== "undefined" && measurementId) {
    // Cargar script de Google Analytics
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    // Inicializar dataLayer
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", measurementId, {
      page_path: window.location.pathname,
    });

    console.log("✅ Google Analytics inicializado:", measurementId);
  }
};

// Rastrear visualización de página
export const trackPageView = (path) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

// Rastrear eventos personalizados
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, eventParams);
    console.log("📊 Evento rastreado:", eventName, eventParams);
  }
};

// Eventos específicos del portfolio

// 1. Descarga de CV
export const trackCVDownload = () => {
  trackEvent("cv_download", {
    event_category: "engagement",
    event_label: "CV Download",
    value: "Abraham Molina CV",
  });
};

// 2. Click en proyecto (GitHub o Demo)
export const trackProjectClick = (projectName, linkType) => {
  trackEvent("project_click", {
    event_category: "engagement",
    event_label: `${projectName} - ${linkType}`,
    project_name: projectName,
    link_type: linkType, // 'github' o 'demo'
  });
};

// 3. Envío de formulario de contacto
export const trackContactFormSubmit = (success) => {
  trackEvent("contact_form_submit", {
    event_category: "conversion",
    event_label: success ? "Success" : "Failed",
    value: success ? 1 : 0,
  });
};

// 4. Click en redes sociales
export const trackSocialClick = (platform) => {
  trackEvent("social_click", {
    event_category: "engagement",
    event_label: platform, // 'LinkedIn', 'GitHub', 'Email'
    platform: platform,
  });
};

// 5. Navegación entre secciones
export const trackSectionView = (sectionName) => {
  trackEvent("section_view", {
    event_category: "navigation",
    event_label: sectionName,
    section: sectionName,
  });
};

// 6. Toggle de modo oscuro
export const trackDarkModeToggle = (mode) => {
  trackEvent("dark_mode_toggle", {
    event_category: "engagement",
    event_label: mode ? "Dark Mode" : "Light Mode",
    mode: mode ? "dark" : "light",
  });
};

// 7. Tiempo en el portfolio (se dispara cada 30s)
export const trackEngagement = (timeSpent) => {
  trackEvent("user_engagement", {
    event_category: "engagement",
    event_label: `Time spent: ${timeSpent}s`,
    engagement_time_msec: timeSpent * 1000,
  });
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackCVDownload,
  trackProjectClick,
  trackContactFormSubmit,
  trackSocialClick,
  trackSectionView,
  trackDarkModeToggle,
  trackEngagement,
};
